import axios from 'axios';
import cookies from 'js-cookie';

import { createApiError } from '@/api/utils/error';
import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { queryKeys } from '@/tanstack-query/query-keys';
import { Country } from '@/types/country';
import { useQuery } from '@tanstack/react-query';

/** Апи получения общего списка стран */
export const getCountries = async (): Promise<Country[]> => {
	try {
		const token = cookies.get(TOKEN_COOKIE_NAME);

		const { data } = await axios.get<Country[]>(`${process.env.HOST}/api_v1/countries/`, {
			headers: { Authorization: token ? `Bearer ${token}` : null },
		});

		return data;
	} catch (error) {
		const errorMessage = 'Ошибка - /api_v1/countries/:';
		throw createApiError(error, errorMessage);
	}
};

export const useCountries = () =>
	useQuery({
		queryKey: queryKeys.countries,
		queryFn: getCountries,
		staleTime: Infinity,
	});
